import { Injectable, HostListener } from '@angular/core';
import { BehaviorSubject, Observable, Subscriber } from 'rxjs';
import { AccessManagerService } from './access.manager.service';

// Menu
export interface Menu {
	path?: string;
	title?: string;
	icon?: string;
	type?: string;
	badgeType?: string;
	badgeValue?: string;
	hasAccess:boolean;
	active?: boolean;
	bookmark?: boolean;
	children?: Menu[];
}

@Injectable({
	providedIn: 'root'
})

export class NavService {

	public screenWidth: any
	public collapseSidebar: boolean = false
	public fullScreen = false;
	roleDetails:any = null;

	constructor() {
		this.onResize();
		if (this.screenWidth < 991) {
			this.collapseSidebar = true
		}
	}

	// Windows width
	@HostListener('window:resize', ['$event'])
	onResize(event?:any) {
		this.screenWidth = window.innerWidth;
	}

	MENUITEMS: Menu[] = [
		{
			title: "Dashboard",
			icon: "home",
			type: "sub",
			hasAccess:false,
			active: true,
			children: [
				{ path: "/dashboard/manager-status", title: "managerstatus", type: "link",active:true,hasAccess:false, },
				{ path: "/sample-page/dashboard", title: "dashboard", type: "link",active:true,hasAccess:false, },
				{ path: "/dashboard/calendar", title: "Calendar", type: "link",active:true,hasAccess:false, }
			],
		 },
		 {
			title: "Sales",
			icon: "trending-up",
			type: "sub",
			hasAccess:false,
			active: true,
			children: [
			  	{ path: "/dashboard/work-status", title: "Sales Board", type: "link",active:true,hasAccess:false, },
			],
		 },
		{
			title: "Clients",
			icon: "users",
			type: "sub",
			active: true,
			hasAccess:false,
			children: [
				{ path: "/sample-page/clients",icon:"users", title: "Customer Details", type: "link",active:true,hasAccess:false },
			  	
			],
		 },
		 {
			title: "Teams",
			icon: "users",
			type: "sub",
			hasAccess:false,
			active: true,
			children: [
			  { path: "/sample-page3/teams", title: "Teams", type: "link",active:true,hasAccess:false }
			],
		 },
		 {
			title: "Services",
			icon: "shopping-cart",
			type: "sub",
			active: true,
			hasAccess:false,
			children: [
			  { path: "/services/service-group", title: "Service Group", type: "link",active:true,hasAccess:false },
			  { path: "/services/services", title: "Services", type: "link",active:true,hasAccess:false },
			  { path: "/services/new-service-page", title: "New Service Page", type: "link",active:true,hasAccess:false },
			]
		 },
		 {
			title: "Users",
			icon: "user-check",
			type: "sub",
			active: true,
			hasAccess:false,
			children: [
			  { path: "/users/users", title: "Users", type: "link",active:true,hasAccess:false },
			]
		 },
		 {
			title: "Admin Portal",
			icon: "windows-lumia",
			type: "sub",
			active: true,
			hasAccess:false,
			children: [
			  { path: "/admin/account-master", title: "Account Master", type: "link",active:true,hasAccess:false },
			  { path: "/sample-page3/society", title: "Society", type: "link",active:true,hasAccess:false }
			]
		 },
		 {
			title: "Drafting",
			icon: "file",
			type: "sub",
			active: true,
			hasAccess:false,
			children: [
				{ path: "/affidavit", title: "Affidavit", type: "link",active:true,hasAccess:false },
				{ path: "/agreement", title: "Agreement", type: "link",active:true,hasAccess:false },
				{ path: "/purchase", title: "After Purchase", type: "link",active:true,hasAccess:false },
				{ path: "/calculator/pmc", title: "Calculator", type: "link",active:true,hasAccess:false },
				{ path: "/banking", title: "Banking", type: "link",active:true,hasAccess:false },
			]
		 },
		  {
			title: "Access Management",
			icon: "edit",
			type: "sub",
			active: true,
			hasAccess:false,
			children: [
				{ path: "/access-management/show-role", title: "role", type: "link",active:true,hasAccess:false },
				{ path: "/access-management/show-module", title: "module", type: "link",active:true,hasAccess:false },
				{ path: "/access-management/show-module-element", title: "module Element", type: "link",active:true,hasAccess:false },
				{ path: "/access-management/assign-module", title: "Assign Module", type: "link",active:true,hasAccess:false },
			]
		 }
	]
	// Array
	items = new BehaviorSubject<Menu[]>(this.MENUITEMS);


}
